import DOMPurify from "dompurify";

/**
 * Safely-sanitised innerHTML shortcut.
 *
 * All places in the codebase that need to render HTML strings (typically
 * translated copy that contains <em>/<strong>/<br/> tags) go through this
 * helper. It runs DOMPurify with the default XSS-safe profile — script tags,
 * event handlers, javascript: URLs, etc. are always stripped.
 *
 * Usage:
 *   <p {...sanitizedHtml(text)} />
 *
 * Rather than the raw:
 *   <p dangerouslySetInnerHTML={{ __html: text }} />
 */
export function sanitizedHtml(html) {
  if (!html) return { dangerouslySetInnerHTML: { __html: "" } };
  return { dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(String(html)) } };
}
